import classNames from 'classnames';
import ReloadIcon from '../../../assets/svg/reload.svg?react';
import FJUtil from '../../../util/FJUtil';
import { useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react';
import styles from './FJCoverImage.module.less';
import FJResourceItemLoading from '../FJResourceItemLoading/FJResourceItemLoading';
import FJConstant from '../../../constants/FJConstant';
import PropTypes from 'prop-types';
import FJImg from './FJImg';
import FJEvent from '../../../store/FJEvent';
const FJCoverImage = (props, ref) => {
    const {
        imgSrc,
        coverImg,
        boxClassName,
        imgClassName,
        loadingClassName,
        isShowLoading = false,
        style,
        children,
        isLoading,
        onClick,
        loadCallback,
        onRefresh,
        reloadStyle,
        addRefreshEvent = false,
    } = props;
    const [stateImgUrl, setStateImgUrl] = useState(imgSrc);
    const [stateCoverImgUrl, setStateCoverImgUrl] = useState(coverImg);
    const [stateIsLoadError, setStateIsLoadError] = useState(false);
    const [stateIsLoaded, setStateIsLoaded] = useState(false);

    const stateIsLoading = isShowLoading && !stateIsLoaded && !stateIsLoadError;
    const unsubscribe = useRef(null);
    useImperativeHandle(ref, () => ({
        refresh: _refresh,
    }));

    useEffect(() => {
        // 如果需要显示loading，则设置状态为loading
        if (imgSrc === stateImgUrl) return;
        setStateImgUrl(imgSrc);
        setStateCoverImgUrl(coverImg);
        loadCallback && loadCallback(FJConstant.LOADING);
    }, [imgSrc, coverImg]);
    const _refresh = e => {
        FJUtil.forbidEvent(e);
        setStateIsLoadError(false);
        setStateIsLoaded(false);
        setStateImgUrl(FJUtil.getReloadNewUrl(imgSrc));
        setStateCoverImgUrl(FJUtil.getReloadNewUrl(coverImg));
        loadCallback && loadCallback(FJConstant.LOADING);
        onRefresh && onRefresh();
        if (addRefreshEvent) {
            unsubscribe.current && unsubscribe.current();
            FJEvent.dispatch(FJConstant.REFRESH_IMAGE);
        }
    };
    const _sourceLoaded = () => {
        setStateIsLoadError(false);
        setStateIsLoaded(true);
        loadCallback && loadCallback(FJConstant.SUCCESS);
    };
    const _sourceError = () => {
        setStateIsLoadError(true);
        setStateIsLoaded(false);
        loadCallback && loadCallback(FJConstant.ERROR);
        if (addRefreshEvent) {
            unsubscribe.current = FJEvent.subscribe(FJConstant.REFRESH_IMAGE, _refresh);
        }
    };
    const _onClick = e => {
        if (stateIsLoading || isLoading) {
            return;
        }
        onClick && onClick(e);
    };

    return (
        <div className={classNames(boxClassName)} onClick={_onClick} style={style}>
            <FJImg
                src={stateImgUrl}
                srcSet={stateCoverImgUrl}
                className={classNames(styles.img, imgClassName)}
                onLoad={_sourceLoaded}
                setIsLoaded={setStateIsLoaded}
                onError={_sourceError}
                style={{ opacity: stateIsLoadError || stateIsLoading ? 0 : 1 }}
                loading='lazy'
            />
            {stateIsLoadError && (
                <div className={styles.reload} style={{ ...reloadStyle }} onClick={_refresh}>
                    <ReloadIcon />
                </div>
            )}
            {children}
            {(stateIsLoading || isLoading) && <FJResourceItemLoading className={loadingClassName} />}
        </div>
    );
};
FJCoverImage.propTypes = {
    imgSrc: PropTypes.string.isRequired,
    boxClassName: PropTypes.string,
    imgClassName: PropTypes.string,
    loadingClassName: PropTypes.string,
    isShowLoading: PropTypes.bool,
    style: PropTypes.object,
    children: PropTypes.node,
    isLoading: PropTypes.bool,
    onClick: PropTypes.func,
    loadCallback: PropTypes.func,
    onRefresh: PropTypes.func,
    reloadStyle: PropTypes.object,
    coverImg: PropTypes.string,
    addRefreshEvent: PropTypes.bool,
};
export default forwardRef(FJCoverImage);
